import React from 'react'

import useSwr from 'swr'

import { Form } from '_zari/core'

import { TiposTablaPersonalizadaConstant } from 'constants/index'

import * as TablasPersonalizadasService from 'services/tablasPersonalizadas.service'

const fetcher = () =>
  TablasPersonalizadasService.getAsSelect(TiposTablaPersonalizadaConstant.MEDIOSPAGO).then(({ data }) => data)

const MedioPagoSelect = props => {
  const { data: mediosPago } = useSwr('select_mediosPago', fetcher, {
    initialData: [],
    revalidateOnMount: true,
    revalidateOnFocus: false,
    dedupingInterval: 1000 * 60 * 15
  })

  return (
    <Form.Select {...props}>
      <option value=''>Seleccionar</option>
      {mediosPago.map((val, key) => (
        <option key={key} value={val._id}>
          {val.nombre}
        </option>
      ))}
    </Form.Select>
  )
}

export default React.memo(MedioPagoSelect)
